import MediaItem from './MediaItem';

export default MediaItem;
